
import { Bounce, Back, gsap} from "gsap";
import { Helper } from "../../dev/utils/Helper";
import { BitmapTextStyleOptions } from '../../dev/setting/text/IText';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { GameAssets } from '../config/texture/GameAssets';
import { BitmapCountUp } from '../component/BitmapCountUp';
import { AnimationEffects } from '../../dev/effects/AnimationEffects';
import { ResizeHelper } from '../../dev/utils/ResizeHelper';


export class FsLeftBox extends PIXI.Container {

    private readonly _style: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_FS_NUMBERS,
        fontSize: 32,
        tint: 0xffffff,
        letterSpacing:0
    };


    protected static _instance: FsLeftBox;

    private isEnabled:boolean = false;

    private _txtAmount: BitmapCountUp;

    protected _timeline: gsap.core.Timeline;

    public static get instance(): FsLeftBox {
        return this._instance;
    }

    constructor() {
        super();
        FsLeftBox._instance = this;
        this.init();
    }

    protected init(): void {
        this.alpha = 0;
        this._txtAmount = this.addChild(new BitmapCountUp(this._style));
        this._txtAmount.showValue(5,false);
        this._txtAmount.pivot.set(50,50)
    }

    enable(val: boolean, durr: number = 0.5): gsap.core.Timeline {
        this.onResize();
        this._timeline = Helper.setTimeline(this._timeline, new gsap.core.Timeline())

        if(val === this.isEnabled) return this._timeline;
        this.isEnabled = val;
        
        const toXPos: number = SlotGame.keypadPlugin.getSpinButtonCenter()!.x;
        const toYPos: number = SlotGame.keypadPlugin.getSpinButtonCenter()!.y;
        
        if (val) {
            this.scale.set(1, 1);
            this._timeline.to(this.position, { x: toXPos, y: toYPos, duration: durr }, 0);
            this._timeline.fromTo(this.scale, { x: 0.75, y: 0.75 }, { x: 1, y: 1, duration: durr, ease:Bounce.easeOut }, 0);
            this._timeline.fromTo(this, { alpha: 0 }, { alpha: 1, duration: durr }, 0);
        } else {
            this._timeline.to(this.scale, { x: 0.8, y: 0.8, duration: durr,ease:Back.easeOut }, 0);
            this._timeline.to(this.position, { x: toXPos, y: toYPos, duration: durr }, 0);
            this._timeline.to(this, { alpha: 0, duration: durr }, 0);
            this._timeline.add(SlotGame.keypadPlugin.show(durr),0);
        }
        return this._timeline;
    }

    get amount(): number {
        return parseFloat(this._txtAmount.text);
    }

    setAmount(val: number): void {
        this._txtAmount.showValue(val,false);
        AnimationEffects.Bounce(this._txtAmount);
    }

    addAmount(val: number): gsap.core.Timeline {

        this._timeline = Helper.setTimeline(this._timeline, new gsap.core.Timeline({ onComplete: () => {} }), true)
        this._timeline.add(() => {this._txtAmount.text = (this.amount + val).toString()});
        this._timeline.add(() => {this._txtAmount.scale.set(1.25,1.25)});
        this._timeline.to(this._txtAmount.scale, { x: 1, y: 1, duration: 0.25, ease: Bounce.easeOut });

        return this._timeline;
    }

    onResize(): void {
        this.visible = !ResizeHelper.isIPadd;
        // Due that the slotkeypad is the last one that updates. We need to skip one frame to get the updated position.
        try {
            SlotGame.keypadPlugin.getSpinButtonCenter();
            setTimeout(() => this.position = SlotGame.keypadPlugin.getSpinButtonCenter())
        } catch {
            setTimeout(() => this.onResize());
        }
    }
}